import React from 'react'
import selectn from 'selectn'
import { AnchorLink } from '../../common'
import { AthleteJersey } from '../../common/Graphics'

export class TopScorers extends React.Component {
  constructor() {
    super()
    this.state = {
      activeTab: ''
    }
  }

  clicked(e, t) {
    if(e && e.preventDefault) {
      e.preventDefault()
    }
    this.setState( { activeTab: t })
  }

  render() {
    const { link={}, players={}, season='', title='',  subtitle='', trackingName='' } = this.props
    if((typeof players === 'undefined') || !players.length ) {
      return <span />
    }
    const heading = `${season} ${title}<span class='league'>${subtitle}</span>`
    const target  = link.external === true ? { target: '_blank' } : {}
    const performers = []
    const tabs = []
    const playerTrackingName = trackingName
    const playersLen = players.length || 0
    for(let e=0; e<playersLen; e++) {
      const topPlayers = selectn('leaders', players[e]) || []
      const topPlayLen = topPlayers.length || 0
      const performersList = []
      const categoryTab = players[e] || []
      this.state.activeTab = this.state.activeTab === '' ? categoryTab.displayCat : this.state.activeTab
      const activeTab = `${this.state.activeTab === categoryTab.displayCat ? ' active' : ''}`
      for(let i=0; i<topPlayLen; i++) {
        const topPlayer = topPlayers[i]
        if(!topPlayLen || topPlayer.name === '' || topPlayer.href ==='') {
          return <li></li>
        }
        let athleteHeadshots
        if(topPlayer.img == '') {
          athleteHeadshots = (
            <div className="headshot-jersey-md fl hs-push-right">
              <AthleteJersey 
                trackingName={playerTrackingName} 
                href={topPlayer.href} 
                jerseyColor={link.teamColor} />
            </div>
          )
        }
        else {
          athleteHeadshots = (
            <div className="img-container player">
              <a name={playerTrackingName} href={topPlayer.href} >
                <img className="focus-image headshot lazyload" data-behavior="fix_broken_images" data-src={topPlayer.img} />
              </a>
            </div>
          )
        }
        performersList.push((
          <li key={i}>
            <div className="content-wrapper">
              {athleteHeadshots}
              <div className="content-meta">
                <p>
                  <a name={playerTrackingName} 
                     href={topPlayer.href}> {topPlayer.name} </a>
                  <span>{topPlayer.position}</span>
                </p>
                <p className="number">{topPlayer.stats}</p>
                <div className="overall-stats">
                  <p>
                    <span>{topPlayer.matches}</span>
                  </p>
                </div>
              </div>
            </div>
          </li>
        ))
      } 
      performers.push((
        <div key={e} className={`tab-pane${activeTab}`}>
          <ul className="module-list performers">
            {performersList} 
          </ul>
        </div>
      ))
      tabs.push((
        <li key={e} className={activeTab} >
          <span onClick={ (e) => {this.clicked(e, categoryTab.displayCat)}}>
            {categoryTab.displayName}
          </span>
        </li>
      ))
    }

    return(
      <article className="sub-module performers" data-module="performers">
        <header>
          <h1 dangerouslySetInnerHTML={{ __html: heading }}></h1>
        </header>
        <div className="tab-container">
          <ul className="tabs" data-behavior="tabs_transform">
            {tabs}
          </ul>
        </div>
        <div className="tab-content">
          {performers}
        </div>
        <footer>
          <AnchorLink trackingName={link.trackingName} to={link.href} text={link.title} {...target} />
        </footer>
       </article>
    )
  }
}

export default TopScorers



// WEBPACK FOOTER //
// ../app/components/common/col-c/TopScorers.jsx